import React, { useEffect, useState } from "react";
import CustomSelect from "../new/inputs/Select";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../store/company";

const CompanySelect = React.forwardRef(
    ({ items = [], params = {}, onDataBound, ...props }, ref) => {
        const [options, setOptions] = useState([]);
        const dispatch = useDispatch();
        const { data, loading, error } = useSelector((state) => state.company);

        useEffect(() => {
            dispatch(fetchData());
        }, []);

        useEffect(() => {
            if (!loading && !error && data && data.length > 0) {
                const dataList = data
                    .filter((item) => item.status === "active")
                    .map((item) => {
                        return {
                            label: item.title_en,
                            value: item.id,
                        };
                    });
                setOptions(dataList);
            }
        }, [data, loading, error]);

        return (
            <CustomSelect
                {...props}
                options={options}
                ref={ref}
                isLoading={loading}
            />
        );
    }
);

export default CompanySelect;
